'use strict';

$ (function () {
    $ ('.aganjs-selectordernumber').click (function () {
        $ ('.orderNumber').addClass ('show');
    });
    
    $ ('.aganjs-removeordernumber').click (function () {
        $ ('.orderNumber').removeClass ('show');
    });
    
    $ (".btn-contact-form-send").click (function () {
        if (!$ ('#toggle-customer-contact').is (':checked') && !$ ('#toggle-newcustomer-contact').is (':checked')) {
            $ (".salutation-btn").addClass ("error");
        }
    });
    
    $ (".salutation-btn input").click (function () {
        if ($ ('#toggle-customer-contact').is (':checked') || $ ('#toggle-newcustomer-contact').is (':checked')) {
            $ (".salutation-btn").removeClass ("error");
        }
    });
    
    $ ('.contact-selected').change (function () {
        var contactDropdowntext;
        var $this = $ (this);
        $ ("select option:selected").each (function () {
            contactDropdowntext = $this.text ();
        });
        var $selectedDropdown = $this.find ('option').eq (this.selectedIndex);
        $ ('.aganjs-default-contactform').val ($selectedDropdown.text ());
    });
});